import instance from '@/utils/instance';

//查询个人书单
export function getPersonalBookList(data, pageNum, pageSize) {
	return instance({
		url: `/webL_api/corporate/acc/queryCatalog/account?pageNum=${pageNum}&pageSize=${pageSize}`,
		method: 'post',
        data
	});
}

//移除个人书单
export function deletePersonalBookRemove(data) {
	return instance({
		url: `/webL_api/corporate/acc/removeCatalog/account`,
		method: 'post',
        data
	});
}

//更新个人书单
export function putPersonalBookUpdate(data) {
	return instance({
		url: `/webL_api/corporate/acc/updateCatalog/account`,
		method: 'post',
		data
	});
}

//新增个人书单
export function postPersonalBookAdd(data) {
	return instance({
		url: `/webL_api/corporate/acc/newCatalog/account`,
		method: 'post',
		data
	});
}
